import { usersUtil, ROLES, TYPES } from 'services/utils/users-util';

function adminUserCanSeeMoney(user) {
  return (
    usersUtil.hasRole(user, ROLES.SPACKLE_ADMIN) ||
    usersUtil.hasRole(user, ROLES.BUSINESS_DEVELOPMENT)
  );
}

function contractorUserCanSeeMoney(user) {
  return (
    usersUtil.hasType(user, TYPES.CONTRACTOR) &&
    (usersUtil.hasRole(user, ROLES.OWNER) ||
      usersUtil.hasRole(user, ROLES.CONTRACTOR_PROJECT_MANAGER))
  );
}

function hasPermissionTeamPage(user) {
  return !!user.accountable_type;
}

function canCreateBuilding(user) {
  let result = false;
  if (
    usersUtil.isAdmin(user) ||
    usersUtil.hasType(user, TYPES.GENERAL_CONTRACTOR)
  ) {
    result = true;
  } else if (usersUtil.hasType(user, TYPES.CLIENT)) {
    result =
      user.roles.filter((role) => role.name !== ROLES.CLIENT_BUILDING_MANAGER)
        .length > 0;
  }

  return result;
}

function showPurchaseOrders(user) {
  return (
    usersUtil.hasType(user, TYPES.CLIENT) &&
    user.accountable &&
    user.accountable.global_po_required
  );
}

function showSurveys(user) {
  return (
    usersUtil.hasRole(user, ROLES.SPACKLE_ADMIN) ||
    (usersUtil.hasType(user, TYPES.CLIENT) &&
      usersUtil.hasRole(user, ROLES.OWNER)) ||
    usersUtil.hasType(user, TYPES.GENERAL_CONTRACTOR)
  );
}

export const PermissionsUtil = {
  adminUserCanSeeMoney: adminUserCanSeeMoney,
  contractorUserCanSeeMoney: contractorUserCanSeeMoney,
  canCreateBuilding: canCreateBuilding,
  hasPermissionTeamPage: hasPermissionTeamPage,
  showPurchaseOrders: showPurchaseOrders,
  showSurveys: showSurveys,
};



// WEBPACK FOOTER //
// ./src/services/utils/permissions-util.js